import React, { useRef } from "react";
import NavigationDrawer from "./../../../components/NavigationDrawer/index";
import AppContainer from "../../../components/AppContainer";
import { MenuItem, Stack } from "@mui/material";
import ExportButton from "../../../components/ExportButton";
import GlobalButton from "../../../components/CustomButton";
import TimeTableCalendar from "./Calendar";
import AddEditTimeTable from "./AddEditTimeTableDialog";
import CustomSelect from "../../../components/customSelect";
import { allIcons } from "../../../assets";

const allClasses = ["Class 1", "Class 2", "Class 3", "Class 4"];
const AllSections = ["Section A", "Section B", "Section C", "Section D"];


const EducationTimeTable = () => {
  const openTimeTableDialog = useRef(null);

  const handleEditTimeTable = () => {
    openTimeTableDialog.current.openDialog({ data: null, type: "edit" });
  };

  const renderRightPart = () => {
    return (
      <Stack
        gap={2}
        direction={"row"}
        alignItems={"center"}
        flex={1}
        justifyContent={"flex-end"}
      >
        <CustomSelect
          formStyleProps={{ width: "25%" }}
          icon={<img src={allIcons.classBlackIcon} width={16} />}
          placeholder={"By Class"}
        >
          {allClasses.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <CustomSelect
          formStyleProps={{ width: "25%" }}
          icon={<img src={allIcons.timerBlackIcon} width={16} />}
          placeholder={"Sections"}
        >
          {AllSections.map((val, index) => {
            return (
              <MenuItem key={index} value={val}>
                {val}
              </MenuItem>
            );
          })}
        </CustomSelect>
        <ExportButton handleClick={() => console.log("helllo")} />
        <GlobalButton
          btnText={"Create New"}
          handleClickBtn={() =>
            openTimeTableDialog.current.openDialog({ data: null, type: "add" })
          }
          styleProps={{ height: 40, width: "auto" }}
        />
      </Stack>
    );
  };
  return (
    <NavigationDrawer>
      <AppContainer
        primaryHeading={"Time Table"}
        secondaryHeading={"Please set time table"}
        headProps={renderRightPart()}
      >
        <TimeTableCalendar handleSelectEvent={handleEditTimeTable} />
      </AppContainer>
      <AddEditTimeTable ref={openTimeTableDialog} />
    </NavigationDrawer>
  );
};

export default EducationTimeTable;
